/* Keep optional cart information with the scrollable items, not above checkout. */
(() => {
  'use strict';
  let scheduled = false;
  const observed = new WeakSet();
  function arrangeCart() {
    scheduled = false;
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    const content = drawer.querySelector('.cart-drawer__content');
    if (content) content.style.overflowY = content.querySelector('.cart-drawer__empty') ? 'auto' : '';
    const items = drawer.querySelector('.cart-drawer__items');
    const extras = drawer.querySelector('.cart-drawer__summary [data-jn-cart-secondary]');
    if (items && extras) items.append(extras);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(arrangeCart);
  }
  function start() {
    arrangeCart();
    const drawer = document.getElementById('CartDrawer');
    if (drawer && !observed.has(drawer)) {
      observed.add(drawer);
      new MutationObserver(schedule).observe(drawer, {childList:true, subtree:true});
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  document.addEventListener('shopify:section:load', start);
})();
